import {
  cardDividerBorderClass,
  cardMutedTextClass,
  cardSurfaceClass,
  cardTitleTextClass,
  compactInputClass,
} from "@/components/common/surfaceClasses";
import {
  createAdsCategory,
  deleteAdsCategory,
  type AdsAssistantCategoryRow,
} from "@/lib/adsAssistantClient";

export function AdsLibraryCategoriesPanel(props: {
  canEdit: boolean;
  categories: AdsAssistantCategoryRow[];
  catSlug: string;
  setCatSlug: (v: string) => void;
  catLabel: string;
  setCatLabel: (v: string) => void;
  setError: (e: string | null) => void;
  setBanner: (b: string | null) => void;
  load: () => Promise<void>;
}) {
  const { canEdit, categories, catSlug, setCatSlug, catLabel, setCatLabel, setError, setBanner, load } = props;

  return (
    <div className={`${cardSurfaceClass} p-3`}>
      <h4 className={`text-xs font-semibold uppercase tracking-wide ${cardMutedTextClass}`}>Categories</h4>
      <ul className="mt-2 max-h-40 space-y-1 overflow-y-auto text-sm">
        {categories.map((c) => (
          <li key={c.id} className={`flex flex-wrap items-center justify-between gap-1 rounded border px-2 py-1 ${cardDividerBorderClass} dark:bg-zinc-900/40`}>
            <span>
              <span className={`font-medium ${cardTitleTextClass}`}>{c.label}</span> <code className={`text-[10px] ${cardMutedTextClass}`}>{c.slug}</code>
            </span>
            {canEdit ? (
              <button
                type="button"
                className="text-[10px] text-red-700 hover:underline dark:text-red-400"
                onClick={async () => {
                  const r = await deleteAdsCategory(c.id);
                  if (!r.ok) {
                    setError(r.error);
                    return;
                  }
                  setBanner("Category removed.");
                  void load();
                }}
              >
                Remove
              </button>
            ) : null}
          </li>
        ))}
        {!categories.length ? <li className={`text-xs ${cardMutedTextClass}`}>No categories yet.</li> : null}
      </ul>
      {canEdit ? (
        <div className={`mt-3 space-y-2 border-t pt-3 ${cardDividerBorderClass}`}>
          <input
            className={`w-full ${compactInputClass}`}
            placeholder="slug (e.g. promo_lot_shot)"
            value={catSlug}
            onChange={(e) => setCatSlug(e.target.value)}
          />
          <input
            className={`w-full ${compactInputClass}`}
            placeholder="Label"
            value={catLabel}
            onChange={(e) => setCatLabel(e.target.value)}
          />
          <button
            type="button"
            className="w-full rounded-lg bg-blue-700 px-2 py-1.5 text-xs font-medium text-white hover:bg-blue-800"
            onClick={async () => {
              const r = await createAdsCategory({ slug: catSlug.trim(), label: catLabel.trim() });
              if (!r.ok) {
                setError(r.error);
                return;
              }
              setCatSlug("");
              setCatLabel("");
              setBanner("Category added.");
              void load();
            }}
          >
            Add category
          </button>
        </div>
      ) : null}
    </div>
  );
}
